const recaptcha = {
	scriptPromise: null,

	loadScript(sitekey) {
		if (this.scriptPromise) {
			return this.scriptPromise
		}

		this.scriptPromise = new Promise((resolve, reject) => {
			if (window.grecaptcha) {
				window.grecaptcha.ready(() => resolve(window.grecaptcha))
				return
			}

			const script = document.createElement('script')
			script.src = `https://www.google.com/recaptcha/api.js?render=${sitekey}`
			script.async = true
			script.onload = () => {
				window.grecaptcha.ready(() => resolve(window.grecaptcha))
			}
			script.onerror = reject
			document.head.appendChild(script)
		})

		return this.scriptPromise
	},

	async getToken(sitekey, action = 'submit') {
		const grecaptcha = await this.loadScript(sitekey)
		return grecaptcha.execute(sitekey, { action })
	}
}

export default recaptcha
